module.exports = __webpack_public_path__ + "img/IMG_1231_L_BlackMatted.6d31ed1a.jpg";